<div
  class="media-carousel"
  [ngClass]="{'smallCarousel': mediumScreen, 'largeCarousel': !mediumScreen}"
>
  @if (mediaContainer.currentMediaType) {
    <div
      class="media-carousel__container"
      [ngClass]="{'can-annotate': canAnnotate()}"
      [attr.data-active-media-size]="activeMediaContainerSize"
      (transitionend)="onActiveMediaResized($event)"
    >
      <div class="media-carousel__top">
        <app-media-carousel-top-menu
          [zoomValue]="zoomValue"
          [isEditing]="isEditing"
          [mediaElements]="mediaContainer.currentMediaType.mediaElements"
          [imageGallery]="imageGallery"
          [mediaIndex]="mediaContainer.currentMediaType.currentMediaIndex"
          [toggleAnnotations]="toggleAnnotations"
          [collapseZoomIn]="collapseZoomInButton"
          [mediumScreen]="mediumScreen"
          [mediaPosition]="mediaPosition"
          [mediaCount]="mediaCount"
          (changedZoomValue)="onChangeZoomValue($event)"
          (openImageFullScreen)="onOpenImageFullScreen($event)"
          (openModelViewer)="onOpenModelFullscreen($event)"
        ></app-media-carousel-top-menu>
      </div>

      @if (mediaContainer.currentMediaType.currentMediaIndex >= 0) {
        <div class="media-carousel__active-image" #container>
          @if (!toggleAnnotations) {
            @if (container) {
              <app-active-media
                [activeMedia]="activeMedia"
                [selectedSegmentId]="mediaContainer.currentSegmentId"
                [zoomValue]="zoomValue"
                [container]="container"
                [fullscreen]="false"
              ></app-active-media>
            }
          }
          @else {
            @if (curAnn && curAnn.annotateImage) {
              <app-active-annotate-image
                [curAnn]="curAnn"
                [imgIndex]="mediaContainer.currentMediaType.currentMediaIndex"
                [zoomValue]="zoomValue"
                [lockHeight]="false"
                [container]="container"
                [edit]="false"
              ></app-active-annotate-image>
            }
          }
        </div>
      }
    </div>
  }
  @if (canAnnotate()) {
    <div class="media-carousel__annotation">
      <mat-slide-toggle
        (change)="toggleAnnotation()"
        [disabled]="isEditing"
        class="media-carousel__annotation-toggle-button"
      >
        <span>
          {{ 'TRANS__IMAGE_CAROUSEL__SHOW_ANNOTATION' | translate }}
        </span>
      </mat-slide-toggle>
      @if (toggleAnnotations && curAnn && curAnn.annotateImage) {
        <app-image-carousel-annotation-points
          [mediaType]="mediaContainer.currentMediaType"
          [curAnn]="curAnn"
          [mediumScreen]="mediumScreen"
          [readonly]="sectionsContainer?.rootObject.read_only">
        </app-image-carousel-annotation-points>
      }
    </div>
  }

  <div class="media-carousel__thumbnails-container">
    @if (!mediumScreen) {
      <div class="thumbnails-header">
        <div class="count">
          {{ 'TRANS__MEDIA_CAROUSEL__MEDIA_COUNT' | translate:{count: mediaCount} }}
        </div>

        <div class="buttons density--4">
          <button
            mat-button
            (click)="onToggleChangeMediaOrder()"
            [disabled]="isEditing || imageGallery"
          >
            <mat-icon matButtonIcon>
              edit
            </mat-icon>

            <span>
              {{ 'TRANS__MEDIA_CAROUSEL__CHANGE_ORDER' | translate }}
            </span>
          </button>

          <button
            mat-button
            [matMenuTriggerFor]="thumbSizeMenu"
          >
            <mat-icon matButtonIcon>
              arrow_drop_down_circle
            </mat-icon>

            <span>
              Størrelser
            </span>
          </button>

          <mat-menu #thumbSizeMenu>
            @for (key of thumbWidthKeys; track $index) {
              <button
                mat-menu-item
                (click)="setThumbWidth(key)"
              >
                <span>
                  {{ thumbSize[key] | translate }}
                </span>
              </button>
            }
          </mat-menu>
        </div>
      </div>

      <div
        class="media-carousel__thumbnail-stack"
        [ngClass]="{'large': mediaContainer.thumbWidth === 'large',
                    'medium': mediaContainer.thumbWidth === 'medium',
                    'small': mediaContainer.thumbWidth === 'small'}"
      >
        @for (mediaType of mediaContainer.mediaTypes; track mediaType) {
          <app-thumbnail-stack
            [mediaContainer]="mediaContainer"
            [mediaType]="mediaType"
            [isEditing]="isEditing"
            [imageGallery]="imageGallery"
            [rootObject]="sectionsContainer?.rootObject"
            (setActiveImg)="onSetActiveMedia(mediaType, $event)"
            (setActiveSegment)="onSetActiveSegment(mediaType, $event)"
          ></app-thumbnail-stack>
        }
      </div>
    }
    @else {
      <div class="media-carousel__thumbnail-carousel-container">
        <app-thumbnail-carousel-nav-button
          class="media-carousel__carousel-nav-button-left"
          [direction]="'prev'"
          [disable]="disablePreviousButton"
          [mediaType]="mediaContainer.currentMediaType"
          (setActiveMediaIndex)="onSetActiveMedia( mediaContainer.currentMediaType, $event, 'prev')"
        ></app-thumbnail-carousel-nav-button>

        <div class="media-carousel__thumbnail-carousel" #mediaElementContainer>
          @for (mediaType of mediaContainer.mediaTypes; track mediaType) {
            <app-thumbnail-carousel
              [ngStyle]="{'width': (mediumScreenThumbnailWidth * mediaType.mediaElements.length) + 'px'}"
              class="media-carousel__thumbnail-carousel-media-type"
              [media]="mediaType.mediaElements"
              [mediaIndex]="mediaContainer.currentMediaType.currentMediaIndex"
              [currentMediaType]="mediaContainer.currentMediaType.mediaType"
              [thumbnailWidth]="mediumScreenThumbnailWidth"
              (setActiveImg)="onSetActiveMedia(mediaType, $event)"
            ></app-thumbnail-carousel>
          }
        </div>

        <app-thumbnail-carousel-nav-button
          class="media-carousel__carousel-nav-button-right"
          [direction]="'next'"
          [disable]="disableNextButton"
          [mediaType]="mediaContainer.currentMediaType"
          (setActiveMediaIndex)="onSetActiveMedia(mediaContainer.currentMediaType, $event, 'next')"
        ></app-thumbnail-carousel-nav-button>
      </div>
    }
  </div>

  @if (showMediaOrder) {
    <div class="overlay"></div>

    <div class="side-selector change-img-order-selector media-carousel__selector">
      <app-change-media-order
        [mediaContainer]="mediaContainer"
        [sectionsContainer]="sectionsContainer"
        (toggleChangeMediaOrder)="onToggleChangeMediaOrder($event)"></app-change-media-order>
    </div>
  }
</div>
